Array.prototype.uniq = function() {
  return this.filter((value, index, self) => self.indexOf(value) === index);
};
